<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.accountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="securityEvidenceDetails.hasPrivilege"
              label="Наличие льготы"
            />
          </v-col>
          <v-col v-if="securityEvidenceDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.securityEvidenceDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.securityEvidenceDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';
import cloneDeep from 'clone-deep';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { checkInvalid, Text, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { SecuringEvidenceStep } from '@/constants';

export default {
  name: 'AccountBankDetails',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    BankDetails,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Text,
    getValidationErrorText,
    invalidFields: [],
    accountBankDetails: cloneDeep(bankDetails),
    securityEvidenceDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      accountBankDetails: bankDetailsValidation,
      securityEvidenceDetails: {
        note: {
          required: requiredIf(() => this.securityEvidenceDetails.hasPrivilege),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const SABD = ServicesModule.statement.accountBankDetails;
      const SSED = ServicesModule.statement.securityEvidenceDetails;

      if (SABD) {
        this.accountBankDetails = { ...this.accountBankDetails, ...SABD };
      }

      if (SSED) {
        this.securityEvidenceDetails = {
          ...this.securityEvidenceDetails,
          ...SSED,
        };
      }
    },

    assemblyModel() {
      if (!this.securityEvidenceDetails.hasPrivilege) {
        this.securityEvidenceDetails.note = null;
      }

      return {
        accountBankDetails: {
          ...this.accountBankDetails,
        },
        securityEvidenceDetails: {
          ...this.securityEvidenceDetails,
        },
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: SecuringEvidenceStep.BANK_DETAILS,
      });
    },
  },
};
</script>
